import React from "react";

/**
 * Server Actionをクリックで実行するためのフック
 * @param action 実行したいServer Actionを含む関数。State以外の引数は渡せない
 * @param initialState 初期状態
 * @returns [state, action, pending]
 */
export function useClickAction<State>(
  action: (state: Awaited<State>) => State | Promise<State>,
  initialState: Awaited<State>,
): [State, () => void, boolean] {
  const [state, dispatch] = React.useActionState<State>(action, initialState);
  const [isPending, startTransition] = React.useTransition();
  const handleAction = () => {
    startTransition(async () => {
      await dispatch();
    });
  };
  return [state, handleAction, isPending] as const;
}
